import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import ConditionalWrapper from "../../atoms/ConditionalWrapper/ConditionalWrapper";
import StartingPage from "../StartingPage/StartingPage";
import Header from "../../templates/Header/Header";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import First from "../../molecules/First/First";
import Seconde from "../../molecules/Seconde/Seconde";
import Third from "../../molecules/Third/Third";
import Fourth from "../../molecules/Fourth/Fourth";
import Fifth from "../../molecules/Fifth/Fifth";
import Sixth from "../../molecules/Sixth/Sixth";
import Seventh from "../../molecules/Seventh/Seventh";
import Eightth from "../../molecules/Eighth/Eighth";
import Ninth from "../../molecules/Ninth/Ninth";
import Tenth from "../../molecules/Tenth/Tenth";
import Eleventh from "../../molecules/Eleventh/Eleventh";
import Twelfth from "../../molecules/Twelfth/Twelfth";
import { Animal } from "../../../types/rtk/animal/animal";
import { AppRoutes } from "../../../routes/AppRoutes";
import { useNavigateWithQuery } from '../../../helpers/useNavigationWithQuery';

interface Props {
  timeLine: number;
  setTimeLine: Dispatch<SetStateAction<number>>;
  formDataFromLocation?: Partial<Animal>;
}

const Wizard = ({
  timeLine,
  setTimeLine,
  formDataFromLocation,
}: Props) => {
  const { t } = useTranslation();
  const navigateWithQuery = useNavigateWithQuery();
  const [formData, setFormData] = useState<Partial<Animal>>({});
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (formDataFromLocation) {
      setFormData(formDataFromLocation);
    }
  }, [formDataFromLocation]);

  const handleNext = () => {
    if (timeLine === 12) {
      navigateWithQuery(AppRoutes.INFOS_VALIDATIONS, {
        state: { formData, noArrow: false },
      });
    } else {
      setTimeLine(timeLine + 1);
    }
  };

  const props = {
    formData: formData,
    setFormData: setFormData,
    timeLine: timeLine,
    setTimeLine: setTimeLine,
    onValidationChange: setIsValid,
  };

  const handleSwitchComponent = () => {
    switch (timeLine) {
      case 0:
        return <StartingPage timeLine={timeLine} setTimeLine={setTimeLine} />;
      case 1:
        return <First {...props} />;
      case 2:
        return <Seconde {...props} />;
      case 3:
        return <Third {...props} />;
      case 4:
        return <Fourth {...props} />;
      case 5:
        return <Fifth {...props} />;
      case 6:
        return <Sixth {...props} />;
      case 7:
        return <Seventh {...props} />;
      case 8:
        return <Eightth {...props} />;
      case 9:
        return <Ninth {...props} />;
      case 10:
        return <Tenth {...props} />;
      case 11:
        return <Eleventh {...props} />;
      case 12:
        return <Twelfth {...props} />;
      default:
        return <p>error</p>;
    }
  };

  return (
    <ConditionalWrapper
      condition={timeLine !== 0}
      wrapper={(children) => (
        <Header timeLine={timeLine} setTimeLine={setTimeLine}>
          {children}
        </Header>
      )}
    >
      <Box className="Wizard">
        {handleSwitchComponent()}
        {timeLine > 0 && timeLine <= 12 && (
          <StyledButton onClick={handleNext} disabled={!isValid}>
            {t("animalInfo:NEXT_BUTTON")}
          </StyledButton>
        )}
      </Box>
    </ConditionalWrapper>
  );
};

export default Wizard;
